import Vue from 'vue'
import VueRouter from 'vue-router'
import StopwatchViewRoot from '../modules/stopwatch/views/StopwatchViewRoot.vue'
import NotFoundView from '../modules/common/views/NotFoundView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Tidtagarur',
    component: StopwatchViewRoot
  },
  {
    path: '*',
    name: '404 - Sidan finns inte',
    component: NotFoundView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
